import { Ability } from "@/interfaces/ability";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useAbilitiesStore = defineStore("abilities", () => {
  const abilities = ref<Ability[]>([]);

  return {
    abilities,

    setAbilities(newAbilities: Ability[]) {
      abilities.value = newAbilities;
    },
  };
});
